/**
 * Patacon Shopify Theme JS
 * Vanilla JS — no dependencies
 */

(function () {
  'use strict';

  /* ══════════════════════════════════════════
     SCROLL REVEAL (IntersectionObserver)
     ══════════════════════════════════════════ */

  var revealObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.08, rootMargin: '0px 0px -60px 0px' }
  );

  function initReveals() {
    document.querySelectorAll('.reveal, .reveal-scale').forEach(function (el) {
      if (!el.classList.contains('visible')) {
        revealObserver.observe(el);
      }
    });
  }

  initReveals();

  /* ══════════════════════════════════════════
     SMOOTH ANCHOR SCROLLING
     ══════════════════════════════════════════ */

  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var href = this.getAttribute('href');
      if (href === '#') return;
      var target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        var top = target.getBoundingClientRect().top + window.pageYOffset - 80;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  });

  /* ══════════════════════════════════════════
     FAQ ACCORDION
     ══════════════════════════════════════════ */

  document.querySelectorAll('.faq-question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = this.closest('.faq-item');
      if (!item) return;

      // Close siblings
      var siblings = item.parentElement.querySelectorAll('.faq-item.open');
      siblings.forEach(function (sib) {
        if (sib !== item) sib.classList.remove('open');
      });

      item.classList.toggle('open');
    });
  });

  /* ══════════════════════════════════════════
     PRICING CARD SELECTION
     ══════════════════════════════════════════ */

  document.querySelectorAll('[data-pricing-cards]').forEach(function (container) {
    var cards = container.querySelectorAll('[data-pricing-card]');

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        // Deactivate all cards in this container
        cards.forEach(function (c) {
          c.classList.remove('pricing-card-active');
        });

        // Activate clicked
        this.classList.add('pricing-card-active');

        // Check the radio
        var radio = this.querySelector('input[type="radio"]');
        if (radio) {
          radio.checked = true;

          // Update hidden variant input in the parent form
          var form = this.closest('form');
          if (!form) {
            var section = this.closest('section') || this.closest('.hero-product-info') || this.closest('.product-info');
            if (section) form = section.querySelector('form[data-add-to-cart-form]');
          }
          if (form) {
            var hiddenInput = form.querySelector('[data-variant-input]');
            if (hiddenInput) {
              hiddenInput.value = radio.value;
            }
          }

          // Update displayed price from the card's own price info
          var cardPrice = this.querySelector('.pricing-price');
          var cardOldPrice = this.querySelector('.pricing-price-old');
          var cardDiscount = this.querySelector('.pricing-discount-tag');
          var section = this.closest('.product-info') || this.closest('.hero-product-info') || this.closest('section');
          if (section && cardPrice) {
            // Find price element — works on both product page and homepage
            var priceEl = section.querySelector('[data-product-price]') || section.querySelector('[data-hero-price]');
            var priceWrap = section.querySelector('.product-price') || section.querySelector('.hero-product-price');
            if (priceEl) {
              priceEl.textContent = cardPrice.textContent.trim();
            }
            if (priceWrap) {
              var compareEl = priceWrap.querySelector('.product-price-compare') || priceWrap.querySelector('.hero-product-price-compare');
              var badgeEl = priceWrap.querySelector('.product-price-badge') || priceWrap.querySelector('.hero-product-price-badge');
              if (cardOldPrice && cardDiscount) {
                if (compareEl) {
                  compareEl.textContent = cardOldPrice.textContent;
                  compareEl.style.display = '';
                } else {
                  compareEl = document.createElement('span');
                  compareEl.className = 'product-price-compare';
                  compareEl.textContent = cardOldPrice.textContent;
                  priceEl.after(compareEl);
                }
                if (badgeEl) {
                  badgeEl.textContent = cardDiscount.textContent;
                  badgeEl.style.display = '';
                } else {
                  badgeEl = document.createElement('span');
                  badgeEl.className = 'product-price-badge';
                  badgeEl.textContent = cardDiscount.textContent;
                  priceWrap.appendChild(badgeEl);
                }
              } else {
                if (compareEl) compareEl.style.display = 'none';
                if (badgeEl) badgeEl.style.display = 'none';
              }
            }
          }
        }
      });
    });
  });

  /* ══════════════════════════════════════════
     AJAX ADD TO CART
     ══════════════════════════════════════════ */

  document.querySelectorAll('[data-add-to-cart-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var submitBtn = form.querySelector('button[type="submit"]');
      if (!submitBtn || submitBtn.disabled) return;

      var variantInput = form.querySelector('[data-variant-input]') || form.querySelector('[name="id"]');
      if (!variantInput) return;

      var originalText = submitBtn.innerHTML;
      submitBtn.disabled = true;
      submitBtn.innerHTML = '<span style="opacity:0.7">Agregando...</span>';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: parseInt(variantInput.value),
          quantity: 1,
        }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Error adding to cart');
          return res.json();
        })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function () {
          submitBtn.innerHTML = originalText;
          submitBtn.disabled = false;
          alert('Error al agregar al carrito. Intenta de nuevo.');
        });
    });
  });

  /* ══════════════════════════════════════════
     CART DRAWER
     ══════════════════════════════════════════ */

  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartDrawerOverlay = document.querySelector('[data-cart-drawer-overlay]');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    if (cartDrawerOverlay) cartDrawerOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    if (cartDrawerOverlay) cartDrawerOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  // Open cart drawer on cart button click
  document.querySelectorAll('.nav-cart-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      if (cartDrawer) {
        e.preventDefault();
        updateCartDrawer();
        openCartDrawer();
      }
    });
  });

  // Close drawer
  if (cartDrawerOverlay) {
    cartDrawerOverlay.addEventListener('click', closeCartDrawer);
  }

  document.querySelectorAll('[data-cart-drawer-close]').forEach(function (btn) {
    btn.addEventListener('click', closeCartDrawer);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCartDrawer();
  });

  // Bind actions for server-rendered cart items
  bindCartDrawerActions();

  /* ══════════════════════════════════════════
     CART DRAWER: FETCH & RENDER
     ══════════════════════════════════════════ */

  function updateCartDrawer() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        updateCartCount(cart.item_count);
      })
      .catch(function () {});
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function renderCartDrawer(cart) {
    var itemsContainer = document.querySelector('[data-cart-drawer-items]');
    var subtotalEl = document.querySelector('[data-cart-subtotal]');
    var footerEl = document.querySelector('.cart-drawer-footer');
    var emptyEl = document.querySelector('[data-cart-drawer-empty]');

    if (!itemsContainer) return;

    if (cart.items.length === 0) {
      itemsContainer.innerHTML = '';
      if (emptyEl) emptyEl.style.display = '';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';
    if (footerEl) footerEl.style.display = '';

    var html = '';
    cart.items.forEach(function (item) {
      var imageUrl = item.image ? getSizedImageUrl(item.image, '120x') : '';
      var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';

      html +=
        '<div class="cart-drawer-item" data-cart-item data-line-item-key="' + item.key + '">' +
          '<div class="cart-drawer-item-image">' +
            '<a href="' + item.url + '">' +
              (imageUrl ? '<img src="' + imageUrl + '" alt="' + escapeHtml(item.title) + '" loading="lazy">' : '') +
            '</a>' +
          '</div>' +
          '<div class="cart-drawer-item-info">' +
            '<a href="' + item.url + '" class="cart-drawer-item-title">' + escapeHtml(item.product_title) + '</a>' +
            (variantTitle ? '<div class="cart-drawer-item-variant">' + escapeHtml(variantTitle) + '</div>' : '') +
            '<div class="cart-drawer-item-price">' + formatMoney(item.final_line_price) + '</div>' +
          '</div>' +
          '<div class="cart-drawer-item-actions">' +
            '<div class="cart-drawer-qty">' +
              '<button type="button" data-change-quantity data-direction="minus" data-key="' + item.key + '" aria-label="Menos">&minus;</button>' +
              '<span data-item-quantity>' + item.quantity + '</span>' +
              '<button type="button" data-change-quantity data-direction="plus" data-key="' + item.key + '" aria-label="M&aacute;s">&plus;</button>' +
            '</div>' +
            '<button type="button" class="cart-drawer-remove" data-remove-item data-key="' + item.key + '" aria-label="Eliminar">' +
              '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>' +
            '</button>' +
          '</div>' +
        '</div>';
    });

    itemsContainer.innerHTML = html;

    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(cart.total_price);
    }

    // Re-bind quantity and remove buttons
    bindCartDrawerActions();
  }

  function bindCartDrawerActions() {
    document.querySelectorAll('[data-change-quantity]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = this.getAttribute('data-key');
        var direction = this.getAttribute('data-direction');
        var qtyEl = this.parentElement.querySelector('[data-item-quantity]');
        var currentQty = parseInt(qtyEl.textContent);
        var newQty = direction === 'plus' ? currentQty + 1 : Math.max(0, currentQty - 1);

        changeCartItem(key, newQty);
      });
    });

    document.querySelectorAll('[data-remove-item]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = this.getAttribute('data-key');
        changeCartItem(key, 0);
      });
    });
  }

  function changeCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        updateCartCount(cart.item_count);
      })
      .catch(function () {});
  }

  /* ══════════════════════════════════════════
     UTILITY FUNCTIONS
     ══════════════════════════════════════════ */

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function getSizedImageUrl(url, size) {
    if (!url) return '';
    var match = url.match(/(.+)(\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp))(.*)$/i);
    if (match) {
      return match[1] + '_' + size + match[2] + match[4];
    }
    return url;
  }

  /* ══════════════════════════════════════════
     CART PAGE QUANTITY BUTTONS
     ══════════════════════════════════════════ */

  document.querySelectorAll('.cart-page [data-change-quantity]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = this.getAttribute('data-line-item-key');
      var direction = this.getAttribute('data-direction');
      var input = this.parentElement.querySelector('input[name="updates[]"]');
      if (!input) return;
      var currentQty = parseInt(input.value) || 1;
      var newQty = direction === 'plus' ? currentQty + 1 : Math.max(0, currentQty - 1);

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty }),
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          window.location.reload();
        })
        .catch(function () {});
    });
  });

  /* ══════════════════════════════════════════
     CURSOR GLOW (desktop only)
     ══════════════════════════════════════════ */

  if (window.matchMedia('(hover: hover)').matches) {
    var glow = document.createElement('div');
    glow.className = 'cursor-glow';
    glow.setAttribute('aria-hidden', 'true');
    document.body.appendChild(glow);

    document.addEventListener('mousemove', function (e) {
      glow.style.left = e.clientX + 'px';
      glow.style.top = e.clientY + 'px';
      if (!glow.classList.contains('active')) glow.classList.add('active');
    });

    document.addEventListener('mouseleave', function () {
      glow.classList.remove('active');
    });
  }
})();
